import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from "../../components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../../components/ui/button";
import SectionHeading from "../../components/common/SectionHeading";

import { faqItems as faqs } from '../../publicAccessible/faq/faqItems';


export default function FAQSection() {
  return (
    <section id="faq" className="section-padding">
      <div className="container-safe">
        <SectionHeading title="Frequently Asked Questions (FAQ)" />

        <div className="bg-background xs:mt-10 mx-auto mt-6 max-w-[800px] md:mt-14">
          <Accordion type="multiple" defaultValue={[faqs[0]?.id ?? ""]}>
            {faqs.slice(0, 4).map((item) => (
              <AccordionItem key={item.id} value={item.id}>
                <AccordionTrigger>{item.q}</AccordionTrigger>
                <AccordionContent>
                  <p>{item.a}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="xs:mt-10 mt-6 flex justify-center md:mt-14">
          <Button asChild variant="link">
            <Link to="/pub/faq">
              Go to all FAQ
              <ArrowRight className="size-6" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
